import { c as _c } from "react/compiler-runtime";
import React, { Suspense, useState } from 'react';
import type { DateValueType } from 'react-tailwindcss-datepicker';
import IconCalendar from '@/assets/icons/heroIcons/Calendar.svg';
import { mergeClasses } from '@/utils/style';
import dynamic from 'next/dynamic';
const DynamicDatePicker = dynamic(() => import('react-tailwindcss-datepicker'), {
  ssr: false
});
export function DatePickerInput(t0) {
  const $ = _c(15);
  const {
    containerClassName,
    defaultValue,
    inputClassName,
    maxDate,
    onChange
  } = t0;
  const t1 = defaultValue?.startDate ?? null;
  const t2 = defaultValue?.endDate ?? null;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      startDate: t1,
      endDate: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [value, setValue] = useState(t3);
  let t4;
  if ($[3] !== onChange) {
    t4 = newValue => {
      if (newValue?.startDate !== null && newValue?.endDate !== null) {
        setValue(newValue);
        onChange?.(newValue);
      }
    };
    $[3] = onChange;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== containerClassName) {
    t5 = mergeClasses("w-full max-w-[21rem] relative", containerClassName);
    $[5] = containerClassName;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== inputClassName) {
    t6 = mergeClasses("input", inputClassName);
    $[7] = inputClassName;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== maxDate || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== value) {
    t7 = <Suspense><DynamicDatePicker startWeekOn="mon" i18n="cs" useRange={false} asSingle={true} value={value} onChange={t4} containerClassName={t5} inputClassName={t6} displayFormat="DD.MM.YYYY" toggleIcon={_temp} maxDate={maxDate} data-clarity-mask="true" /></Suspense>;
    $[9] = maxDate;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = value;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp() {
  return <IconCalendar className="text-blue-500" />;
}